import { styled } from '@mui/material';

export const PreviewSurface = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 2,
  background: '#eef3f6',
});

export const GaugePreview = styled('svg')({
  width: '94%',
  height: '94%',
  '& path': {
    fill: 'none',
    strokeWidth: 10,
    strokeLinecap: 'butt',
  },
  '& line': {
    stroke: '#0d1b2a',
    strokeWidth: 2.5,
    strokeLinecap: 'round',
  },
  '& circle': {
    fill: '#0d1b2a',
  },
});